export default __webpack_public_path__ + "static/media/refresh.e581ba84.svg";